export const GRADE_BANDS = [
  { minimum: 90, grade: "A" },
  { minimum: 85, grade: "B+" },
  { minimum: 75, grade: "B" },
  { minimum: 70, grade: "C+" },
  { minimum: 60, grade: "C" },
  { minimum: 50, grade: "D" },
  { minimum: 0, grade: "F" },
] as const

export type ProficiencyLevel = "Beginning" | "Developing" | "Proficient" | "Advanced"

export function getGradeForScore(score: number | null): string | null {
  if (score === null || !Number.isFinite(score)) return null
  return GRADE_BANDS.find((band) => score >= band.minimum)?.grade ?? "F"
}

export function getProficiencyForScore(score: number | null): ProficiencyLevel | null {
  if (score === null || !Number.isFinite(score)) return null
  if (score >= 85) return "Advanced"
  if (score >= 70) return "Proficient"
  if (score >= 50) return "Developing"
  return "Beginning"
}

export function getAcademicAssessment(score: number | null) {
  return {
    grade: getGradeForScore(score),
    proficiency: getProficiencyForScore(score),
  }
}
